import React, { useEffect, useState } from "react";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import { Grid, MenuItem, Typography } from "@mui/material";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { NavigateFunction, useNavigate } from "react-router-dom";
import FilterSelect from "../../../components/select/filterSelect";
import CardChat from "../../../components/card/CardChat";
import CustomStatus from "../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import InputTextField from "../../../components/input/inputTextField";
import { useDispatch, useSelector } from "react-redux";
import { advisorTypeApi } from "../../../api/advisor-type/advisor-type.api";
import { advisorApi } from "../../../api/advisor/advisor.api";
import { EmployeeApi } from "../../../api/employee/employee.api";
import { unsetLoading } from "../../../store/loading/loading.slice";
import { advisorStudentApi } from "../../../api/advisor-student/advisor-student.api";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { dataEvaluation } from "../../../utils/usage_form_evluation";
import AutocompleteSelect from "../../../components/select/autoCompleteSelect";
import {
  handleColorStatusConsultRequestUtil,
  handleTextStatusConsultRequestUtil,
} from "../../../utils/statusRequest";
import { useTranslation } from "react-i18next";

const AdvisorConsultationDetail = () => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { profile } = useSelector((state: any) => state.profile);
  const { id } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const advisor_id = queryParams.get("advisor_id");
  const grade_level = queryParams.get("grade_level");
  const faculty_name = queryParams.get("faculty_name");

  const [inputValue, setInputValue] = useState({
    selected_usage_type: "",
    selected_advisor_type: 0,
    selected_advisor_type_name: "",
    selected_advisor_id: 0,
    selected_employee_id: 0,
    detail: "",
    new_message: "",
    //
    status: "",
    last_updated_by: "",
  });

  const [singleData, setSingleData] = useState<any>({});

  const [chatDetail, setChatDetail] = useState<any[]>([]);

  const [dataAdvisorType, setDataAdvisorType] = useState<any[]>([]);
  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);
  const [singleDataStudent, setSingleDataStudent] = useState<any>({});

  const handleChangeValue = (name: string, value: any) => {
    setInputValue((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getAdvisorType = async () => {
    const res = await advisorTypeApi.getAllAdvisorType();

    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorType(data.data.items);
    } else {
      setDataAdvisorType([]);
    }
  };

  const getDataAdvisor = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await advisorApi.getAllAdvisor(query);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisor(data.data.items);
    } else {
      setDataAdvisor([]);
    }
  };

  const getDataEmployee = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await EmployeeApi.list(query);
    const data = res.data;
    if (data.status < 300) {
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  useEffect(() => {
    getAdvisorType();
    getDataAdvisor();
    getDataEmployee();
  }, []);

  const getSingleDataConsultation = async (id: number) => {
    const res = await advisorStudentApi.getAdvisorStudentById(id);
    const data = res.data;
    if (data.status < 300) {
      let parsedAdvisorStudentDetail = {} as any;

      console.log("advisorStudentFile", data?.data.advisorStudentFile);

      try {
        parsedAdvisorStudentDetail = JSON.parse(
          data?.data.advisor_student_detaill
        );
      } catch (error) {
        console.error("Error parsing advisor_student_detaill:", error);
      }

      setInputValue({
        selected_usage_type: data.data?.advisor_group ?? "-",
        selected_advisor_type: parsedAdvisorStudentDetail?.advisor_type ?? 0,
        selected_advisor_type_name:
          parsedAdvisorStudentDetail?.advisor_type_name ?? "-",
        selected_advisor_id: data.data?.id_advisor ?? "-",
        selected_employee_id: data.data?.id_employee ?? "-",
        detail: parsedAdvisorStudentDetail.detail ?? "-",
        new_message: "",
        status: parsedAdvisorStudentDetail.status ?? "",
        last_updated_by: parsedAdvisorStudentDetail.last_updated_by ?? "",
      });
      setSingleData(parsedAdvisorStudentDetail);
      setSingleDataStudent(data.data?.student ?? {});

      const fileData = data?.data.advisorStudentFile ?? [];
      const chatData = parsedAdvisorStudentDetail.chat;

      const mergedData = [
        // Map chat data
        ...chatData.map((chat: any) => ({
          chat_id: chat.chat_id,
          chat_type: chat.chat_type,
          message: chat.message,
          send_date: chat.send_date,
          send_by: chat.send_by,
          send_to: chat.send_to,
          content_type: "text",
          file: null,
        })),
        // Map file data
        ...fileData.map((file: any) => ({
          chat_id: file.id_advisor_student_file,
          chat_type: "file",
          message: null,
          send_date: file.created_date,
          send_by: file.created_id,
          send_to: null, // Use the same `send_to` as chat
          content_type: "file",
          file,
        })),
      ];

      const uniqueMergedData = mergedData.reduce((acc, item) => {
        // Check if the chat_id already exists in the accumulator
        if (
          !acc.some(
            (existingItem: any) => existingItem.chat_id === item.chat_id
          )
        ) {
          acc.push(item); // Add item if it's not a duplicate
        }
        return acc;
      }, []);

      setChatDetail(uniqueMergedData ?? []);
    } else {
      setInputValue({
        selected_usage_type: "",
        selected_advisor_type: 0,
        selected_advisor_type_name: "",
        selected_advisor_id: 0,
        selected_employee_id: 0,
        detail: "",
        new_message: "",
        status: "",
        last_updated_by: "",
      });
      setSingleData({});
      setChatDetail([]);
    }
  };

  useEffect(() => {
    if (id) {
      getSingleDataConsultation(+id);
    }
  }, [id]);

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: t("จัดการอาจารย์ที่ปรึกษาวิทยานิพนธ์"),
            key: "1",
            pathName: routeName.cms.manageAdvisors,
          },
          {
            name: t("ข้อมูลอาจารย์ที่ปรึกษา HR approve"),
            key: "2",
            pathName: routeName.cms.manageAdvisors + `/${advisor_id}/detail`,
          },
          {
            name: t("เรื่องขอคำปรึกษา"),
            key: "3",
            pathName:
              routeName.cms.manageAdvisors + `/consultation-detail/${id}`,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">
          {t("ส่งเรื่องขอคำปรึกษา")}{" "}
          <CustomStatus
            label={handleColorStatusConsultRequestUtil(
              inputValue?.status,
              profile && profile.user_type
            )}
            type="outlined"
            color={handleTextStatusConsultRequestUtil(inputValue?.status)}
            icon={<FiberManualRecord />}
            width="250px"
          />
        </Typography>
      </section>

      <Grid container spacing={2} alignItems="starts">
        <Grid item xs={12} sm={4}>
          <Typography variant="subtitle1">
            {t("ชื่อ - นามสกุล :")}{" "}
            {singleDataStudent.title +
              " " +
              singleDataStudent.student_frist_name +
              " " +
              singleDataStudent.student_last_name}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Typography variant="subtitle1">
            {t("ฉายา :")}{singleDataStudent?.student_nickname}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Typography variant="subtitle1">
            {t("รหัสประจำตัวนักศึกษา :")} {singleDataStudent?.student_no}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={1}>
          <Typography variant="subtitle1">
            {t("ชั้นปีที่ :")}{grade_level}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography variant="subtitle1">
            {t("หลักสูตร :")} {faculty_name}
          </Typography>
        </Grid>
      </Grid>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
          <FilterSelect
            heading={t("เลือกประเภท")}
            value={inputValue.selected_usage_type ?? ""}
            labelId="type-id"
            selectId="type-select-id"
            options={[
              {
                id_type: "",
                type_name: t("เลือกประเภท"),
              },
              ...dataEvaluation.map((list) => ({
                id_type: list.id,
                type_name: list.name,
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_type} key={index + 1}>
                {t(list.type_name)}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValue("selected_usage_type", e.target.value)
            }
            disabled
          />
        </article>

        {inputValue &&
          // i18n-ignore
          inputValue.selected_usage_type === "อาจารย์ที่ปรึกษาประจำชั้น" && (
            <>
              <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                <FilterSelect
                  heading={t("ประเภทคำปรึกษา")}
                  value={inputValue.selected_advisor_type ?? ""}
                  labelId="type-id"
                  selectId="type-select-id"
                  options={[
                    {
                      id_type: "0",
                      type_name: t("ประเภทคำปรึกษา"),
                    },
                    ...dataAdvisorType.map((list) => ({
                      id_type: list.id_advisor_type,
                      type_name: list.advisor_type_name,
                    })),
                  ].map((list, index) => (
                    <MenuItem value={list.id_type} key={index + 1}>
                      {list.type_name}
                    </MenuItem>
                  ))}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setInputValue({
                      ...inputValue,
                      selected_advisor_type: +e.target.value,
                    });
                    setInputValue({
                      ...inputValue,
                      selected_advisor_type_name:
                        dataAdvisorType.find(
                          (list) => list.id_advisor_type === e.target.value
                        ).advisor_type_name || "",
                    });
                  }}
                  disabled
                />
              </article>
            </>
          )}

        {inputValue &&
          // i18n-ignore
          inputValue.selected_usage_type === "อาจารย์ที่ปรึกษาประจำรายวิชา" && (
            <>
              <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12"></article>

              <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                <AutocompleteSelect
                  heading={t("รายวิชา")}
                  freeSolo
                  labelId={"-"}
                  options={dataAdvisor ?? []}
                  getOptionLabel={(option: any) =>
                    `${option?.first_name}||~~${option?.last_name || "-"}` || ""
                  }
                  renderOption={(props, option) => (
                    <li
                      {...props}
                    >{`${option?.first_name} ${option?.last_name}`}</li>
                  )}
                  // value={inputValue.adv_employee_id ?? null}
                  onChange={(_, value: any) => {
                    console.log("value", value);
                    if (value) {
                      // handleChangeValue(
                      //   "selected_advisor_id",
                      //   value.id_advisor
                      // );
                      // handleChangeValue(
                      //   "selected_employee_id",
                      //   value.id_employee
                      // );
                    }
                  }}
                  disabled
                />
              </article>
            </>
          )}

        <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mt-4">
          <CardChat
            data={
              (chatDetail &&
                chatDetail?.map((item: any, index: number) => ({
                  id: item.chat_id,
                  type:
                    item.chat_type === "student"
                      ? t("นักศึกษา")
                      : t("อาจารย์ที่ปรึกษา"),
                  sender:
                    profile && profile.id_user === item.send_by ? "me" : "you",
                  message: item.message,
                  date: item.send_date,
                  content_type: item.content_type,
                  file: item.file,
                }))) ??
              []
            }
          />
        </article>
      </div>
    </div>
  );
};

export default AdvisorConsultationDetail;
